import React, { createContext, Dispatch, ReactNode, SetStateAction, useMemo, useState } from 'react';

type TableContextProps = {
  headers: string[] | undefined;
  setHeaders: Dispatch<SetStateAction<string[] | undefined>>;
  columns: string[] | undefined;
  setColumns: Dispatch<SetStateAction<string[] | undefined>>;
  visibleHeaders: boolean[] | undefined;
  setVisibleHeaders: Dispatch<SetStateAction<boolean[] | undefined>>;
};
export const TableContext = createContext<TableContextProps>({
  columns: [],
  setColumns: () => {},
  headers: [],
  setHeaders: () => {},
  visibleHeaders: [],
  setVisibleHeaders: () => {},
});

const TableProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [columns, setColumns] = useState<string[] | undefined>(undefined);
  const [headers, setHeaders] = useState<string[] | undefined>(undefined);
  const [visibleHeaders, setVisibleHeaders] = useState<boolean[] | undefined>(undefined);

  const contextValue = useMemo(() => ({
    headers,
    setHeaders,
    columns,
    setColumns,
    visibleHeaders,
    setVisibleHeaders,
  }), [
    headers,
    setHeaders,
    columns,
    setColumns,
    visibleHeaders,
    setVisibleHeaders,
  ]);

  return (
    <TableContext.Provider value={contextValue}>
      {children}
    </TableContext.Provider>
  );
};

export default TableProvider;
